var _PropTypes$shape, _PropTypes$shape2;

import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import React from 'react';
import * as _ from "../../../util/lodash";
import { createComponent, PropTypes } from "../../../wayin-react";
import Panel from "./../panel";
import Input from "./../../core/input";
import TextArea from "./../../core/textarea";
import Layout from "./../../core/layout";
import Button from "./../../core/button";
import AssetUploader from "./../../core/asset-uploader";
import CTADropdown from "./../call-to-action/cta-dropdown";
import TextEditor from "../text-editor";
import { colors, copyEditorFields, icons, sizes, widths, richTextToolbar } from "../../../enums";
import Validators from "../../../validators";
import ValidatableCTADropdown from "./../call-to-action/validatable-cta-dropdown"; //  validation field id if it applies

var CTA_FIELD_ID = 'ctaLink'; //  for testing

export var _test = {
  CTA_FIELD_ID: CTA_FIELD_ID
};
var ValidatableCTA = ValidatableCTADropdown({
  isUrl: Validators.isCTALink(),
  isRequired: function isRequired(value) {
    if (value === undefined || value === '' || value === 'http://') {
      return Validators.Messages.RequiredMessage;
    }
  }
});
/**
 *  Helper method to get the intial state of fields toggled from the passed in panels prop
 *  @param the props object from parent
 *  @return an object representing fields toggled
 */

var getToggledFields = function getToggledFields(p) {
  var displayFields = p.displayFields,
      toggledByDefault = p.toggledByDefault,
      copyConfig = p.copyConfig;

  if (displayFields.length > 0) {
    var fieldsToggled = {};

    _.each(displayFields, function (field) {
      fieldsToggled[field] = _indexOfInstanceProperty(_).call(_, toggledByDefault, field) > -1 || (_.property(field)(copyConfig) ? true : false);
      /*!= null //checking for null would return true for empty string, so commenting out */
    }); //  show cta link if 'linkText' exists in copy editor and displayFields contain 'link'


    var showCTALink = _.get(fieldsToggled, 'link') || _indexOfInstanceProperty(_).call(_, displayFields, 'link') > -1 && _.get(copyConfig, 'linkText');

    _.set(fieldsToggled, 'link', showCTALink);

    return fieldsToggled;
  }
};
/**
 *  Helper method to create the flex callout panel.  This method will be retrofitted with the new flex callout design later.
 *  @param provided props
 *  @returns the markup for the flex callout if configured for the module
 *
 */


var getCopyPanel = function getCopyPanel(p) {
  var header = p.header,
      byline = p.byline,
      hasBorder = p.hasBorder,
      copyConfig = p.copyConfig,
      displayFields = p.displayFields,
      mentionFields = p.mentionFields,
      mentionList = p.mentionList,
      richTextFields = p.richTextFields,
      featureImageUploadLabel = p.featureImageUploadLabel,
      featureImageSelectLabel = p.featureImageSelectLabel,
      featureImageAllowAltText = p.featureImageAllowAltText,
      backgroundImageUploadLabel = p.backgroundImageUploadLabel,
      backgroundImageSelectLabel = p.backgroundImageSelectLabel,
      backgroundImageAllowAltText = p.backgroundImageAllowAltText,
      fieldsToggled = p.fieldsToggled,
      libraryRef = p.libraryRef,
      containerRef = p.containerRef,
      featureImageIdentifier = p.featureImageIdentifier,
      backgroundImageIdentifier = p.backgroundImageIdentifier,
      toolbarOptionsSingleLine = p.toolbarOptionsSingleLine,
      toolbarOptionsMultiLine = p.toolbarOptionsMultiLine;

  var ctaList = _mapInstanceProperty(_).call(_, p.ctaList, function (option) {
    return {
      value: option.value,
      text: option.text
    };
  });

  if (displayFields.length > 0 && fieldsToggled) {
    return /*#__PURE__*/React.createElement(Panel, {
      header: header,
      byline: byline,
      hasBorder: !!hasBorder,
      style: p.style
    }, /*#__PURE__*/React.createElement(Layout, {
      columns: widths.ONE
    }, fieldsToggled.tagline ? /*#__PURE__*/React.createElement(TextEditor, {
      isRichEditor: richTextFields[copyEditorFields.TAGLINE],
      useMentions: mentionFields[copyEditorFields.TAGLINE],
      mentionList: mentionList,
      isMultiline: false,
      toolbarOptions: toolbarOptionsSingleLine,
      label: "Tagline",
      value: copyConfig.tagline,
      id: "tagline",
      onChange: p.onChange,
      innerRef: p.setTagline
    }) : null, fieldsToggled.heading ? /*#__PURE__*/React.createElement(TextEditor, {
      isRichEditor: richTextFields[copyEditorFields.HEADING],
      useMentions: mentionFields[copyEditorFields.HEADING],
      mentionList: mentionList,
      isMultiline: richTextFields[copyEditorFields.HEADING],
      toolbarOptions: toolbarOptionsMultiLine,
      label: "Heading",
      value: copyConfig.heading,
      id: "heading",
      onChange: p.onChange,
      innerRef: p.setHeading
    }) : null, fieldsToggled.byline ? /*#__PURE__*/React.createElement(TextEditor, {
      isRichEditor: richTextFields[copyEditorFields.BYLINE],
      useMentions: mentionFields[copyEditorFields.BYLINE],
      mentionList: mentionList,
      isMultiline: richTextFields[copyEditorFields.BYLINE],
      toolbarOptions: toolbarOptionsMultiLine,
      label: "Byline",
      value: copyConfig.byline,
      id: "byline",
      onChange: p.onChange,
      innerRef: p.setByline
    }) : null, fieldsToggled.description ? /*#__PURE__*/React.createElement(TextEditor, {
      isRichEditor: richTextFields[copyEditorFields.DESCRIPTION],
      useMentions: mentionFields[copyEditorFields.DESCRIPTION],
      mentionList: mentionList,
      isMultiline: true,
      toolbarOptions: toolbarOptionsMultiLine,
      label: "Description",
      value: copyConfig.description,
      id: "description",
      onChange: p.onChange,
      innerRef: p.setDescription
    }) : null, fieldsToggled.helpText ? /*#__PURE__*/React.createElement(TextArea, {
      label: "Help Text",
      value: copyConfig.helpText,
      id: "helpText",
      onChange: p.onChange,
      innerRef: p.setHelpText
    }) : null, fieldsToggled.linkText ? /*#__PURE__*/React.createElement(Input, {
      label: p.linkTextLabel,
      value: copyConfig.linkText,
      id: "linkText",
      onChange: p.onChange,
      innerRef: p.setLinkText
    }) : null, fieldsToggled.featureImageAssetRef ? /*#__PURE__*/React.createElement(Layout.Row, null, /*#__PURE__*/React.createElement(AssetUploader.Image, {
      id: "featureImageAssetRef",
      label: "Image",
      isFluid: true,
      uploadButtonText: featureImageUploadLabel,
      selectButtonText: featureImageSelectLabel,
      stateIdentifier: featureImageIdentifier,
      value: copyConfig.featureImageAssetRef,
      onChange: p.onChange,
      key: featureImageIdentifier,
      libraryRef: libraryRef,
      containerRef: containerRef,
      allowAltText: featureImageAllowAltText,
      altText: copyConfig.featureImageAssetRefAltText,
      onAltTextChange: p.onChange
    })) : null, fieldsToggled.link ? !!p.formId ? /*#__PURE__*/React.createElement(ValidatableCTA, {
      id: "ctaLink",
      formId: p.formId,
      fieldId: CTA_FIELD_ID,
      shouldDeregisterOnUnmount: true,
      validateOn: 'onChange',
      label: "CTA",
      buttonText: copyConfig.linkText,
      options: ctaList,
      onChange: p.handleCtaLinkChange,
      onButtonTextChange: p.handleCtaLinkTextChange,
      value: copyConfig.link || '',
      innerRef: p.setCtaLink
    }) : /*#__PURE__*/React.createElement(CTADropdown, {
      id: "ctaLink",
      label: "CTA",
      buttonText: copyConfig.linkText,
      options: ctaList,
      onChange: p.handleCtaLinkChange,
      onButtonTextChange: p.handleCtaLinkTextChange,
      value: copyConfig.link || '',
      innerRef: p.setCtaLink
    }) : null, fieldsToggled.price ? /*#__PURE__*/React.createElement(Layout.Row, null, /*#__PURE__*/React.createElement(Input, {
      label: "Price",
      value: copyConfig.price,
      id: "price",
      onChange: p.onChange,
      innerRef: p.setPrice
    })) : null, fieldsToggled.backgroundImageAssetRef ? /*#__PURE__*/React.createElement(Layout.Row, null, /*#__PURE__*/React.createElement(AssetUploader.Image, {
      id: "backgroundImageAssetRef",
      label: "Background",
      isFluid: true,
      uploadButtonText: backgroundImageUploadLabel,
      selectButtonText: backgroundImageSelectLabel,
      stateIdentifier: backgroundImageIdentifier,
      value: copyConfig.backgroundImageAssetRef,
      onChange: p.onChange,
      key: backgroundImageIdentifier,
      libraryRef: libraryRef,
      containerRef: containerRef,
      allowAltText: backgroundImageAllowAltText,
      altText: copyConfig.backgroundImageAssetRefAltText,
      onAltTextChange: p.onChange
    })) : null, /*#__PURE__*/React.createElement(Layout.Row, {
      columns: 'equal'
    }, /*#__PURE__*/React.createElement(Button.Group, {
      spacing: sizes.SMALL,
      style: {
        marginLeft: '-12px'
      }
    }, /*#__PURE__*/React.createElement(Button.Secondary, {
      icon: icons.PLUS,
      isCompact: true,
      onClick: _.noop,
      color: colors.ACCENT,
      size: sizes.MEDIUM
    }), _indexOfInstanceProperty(_).call(_, displayFields, copyEditorFields.TAGLINE) > -1 ? /*#__PURE__*/React.createElement(Button.Secondary, {
      isCompact: true,
      isActive: fieldsToggled.tagline === true,
      id: "tagline",
      onClick: p.toggleCopyOption,
      color: fieldsToggled.tagline ? colors.ACCENT : colors.BASE,
      text: "Tagline"
    }) : null, _indexOfInstanceProperty(_).call(_, displayFields, copyEditorFields.HEADING) > -1 ? /*#__PURE__*/React.createElement(Button.Secondary, {
      isCompact: true,
      isActive: fieldsToggled.heading === true,
      id: "heading",
      onClick: p.toggleCopyOption,
      color: fieldsToggled.heading ? colors.ACCENT : colors.BASE,
      text: "Heading"
    }) : null, _indexOfInstanceProperty(_).call(_, displayFields, copyEditorFields.BYLINE) > -1 ? /*#__PURE__*/React.createElement(Button.Secondary, {
      isCompact: true,
      isActive: fieldsToggled.byline === true,
      id: "byline",
      onClick: p.toggleCopyOption,
      color: fieldsToggled.byline ? colors.ACCENT : colors.BASE,
      text: "Byline"
    }) : null, _indexOfInstanceProperty(_).call(_, displayFields, copyEditorFields.DESCRIPTION) > -1 ? /*#__PURE__*/React.createElement(Button.Secondary, {
      isCompact: true,
      isActive: fieldsToggled.description === true,
      id: "description",
      onClick: p.toggleCopyOption,
      color: fieldsToggled.description ? colors.ACCENT : colors.BASE,
      text: "Description"
    }) : null, _indexOfInstanceProperty(_).call(_, displayFields, copyEditorFields.HELP_TEXT) > -1 ? /*#__PURE__*/React.createElement(Button.Secondary, {
      isCompact: true,
      isActive: fieldsToggled.helpText === true,
      id: "helpText",
      onClick: p.toggleCopyOption,
      color: fieldsToggled.helpText ? colors.ACCENT : colors.BASE,
      text: "Help Text"
    }) : null, _indexOfInstanceProperty(_).call(_, displayFields, copyEditorFields.LINK_TEXT) > -1 ? /*#__PURE__*/React.createElement(Button.Secondary, {
      isCompact: true,
      isActive: fieldsToggled.linkText === true,
      id: "linkText",
      onClick: p.toggleCopyOption,
      color: fieldsToggled.linkText ? colors.ACCENT : colors.BASE,
      text: p.linkTextLabel
    }) : null, _indexOfInstanceProperty(_).call(_, displayFields, copyEditorFields.FEATURE_IMAGE) > -1 ? /*#__PURE__*/React.createElement(Button.Secondary, {
      isCompact: true,
      isActive: fieldsToggled.featureImageAssetRef === true,
      id: "featureImageAssetRef",
      onClick: p.toggleCopyOption,
      color: fieldsToggled.featureImageAssetRef ? colors.ACCENT : colors.BASE,
      text: "Image"
    }) : null, _indexOfInstanceProperty(_).call(_, displayFields, copyEditorFields.LINK) > -1 ? /*#__PURE__*/React.createElement(Button.Secondary, {
      isCompact: true,
      isActive: fieldsToggled.link === true,
      onClick: p.toggleCtaOption,
      color: fieldsToggled.link ? colors.ACCENT : colors.BASE,
      text: "CTA"
    }) : null, _indexOfInstanceProperty(_).call(_, displayFields, copyEditorFields.BACKGROUND_IMAGE) > -1 ? /*#__PURE__*/React.createElement(Button.Secondary, {
      isCompact: true,
      isActive: fieldsToggled.backgroundImageAssetRef === true,
      id: "backgroundImageAssetRef",
      onClick: p.toggleCopyOption,
      color: fieldsToggled.backgroundImageAssetRef ? colors.ACCENT : colors.BASE,
      text: "Background"
    }) : null, _indexOfInstanceProperty(_).call(_, displayFields, copyEditorFields.PRICE) > -1 ? /*#__PURE__*/React.createElement(Button.Secondary, {
      isCompact: true,
      isActive: fieldsToggled.price === true,
      id: "price",
      onClick: p.toggleCopyOption,
      color: fieldsToggled.price ? colors.ACCENT : colors.BASE,
      text: "price"
    }) : null))));
  } else {
    return null;
  }
};
/**
 * Component for editing a modules 'copy' properties.
 */


var CopyEditor = createComponent({
  displayName: 'CopyEditor',
  propTypes: {
    header: PropTypes.string,
    byline: PropTypes.string,
    //to be used with the cta dropdown, to show possible values to choose from
    ctaList: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string
    })),
    //other props to be passed to the asset uploaders.
    libraryRef: PropTypes.string,
    containerRef: PropTypes.string,
    featureImageIdentifier: PropTypes.string,
    featureImageUploadLabel: PropTypes.string,
    featureImageSelectLabel: PropTypes.string,
    featureImageAllowAltText: PropTypes.bool,
    backgroundImageIdentifier: PropTypes.string,
    backgroundImageUploadLabel: PropTypes.string,
    backgroundImageSelectLabel: PropTypes.string,
    backgroundImageAllowAltText: PropTypes.bool,
    //module data edited by the copy editor. It can contain other properties too, including ones referenced by props.mainImageName and props.backgroundImageName
    copyConfig: PropTypes.shape({
      tagline: PropTypes.string,
      heading: PropTypes.string,
      byline: PropTypes.string,
      description: PropTypes.string,
      helpText: PropTypes.string,
      link: PropTypes.string,
      linkText: PropTypes.string,
      featureImageAssetRef: PropTypes.string,
      featureImageAssetRefAltText: PropTypes.string,
      backgroundImageAssetRef: PropTypes.string,
      backgroundImageAssetRefAltText: PropTypes.string
    }).isRequired,
    displayFields: PropTypes.arrayOf(PropTypes.oneOf(copyEditorFields.ALL)),
    //array of fields to show in the copy editor
    mentionFields: PropTypes.shape((_PropTypes$shape = {}, _PropTypes$shape[copyEditorFields.TAGLINE] = PropTypes.bool, _PropTypes$shape[copyEditorFields.HEADING] = PropTypes.bool, _PropTypes$shape[copyEditorFields.BYLINE] = PropTypes.bool, _PropTypes$shape[copyEditorFields.DESCRIPTION] = PropTypes.bool, _PropTypes$shape)),
    //fields that will show up mentions
    mentionList: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string
    })),
    richTextFields: PropTypes.shape((_PropTypes$shape2 = {}, _PropTypes$shape2[copyEditorFields.TAGLINE] = PropTypes.bool, _PropTypes$shape2[copyEditorFields.HEADING] = PropTypes.bool, _PropTypes$shape2[copyEditorFields.BYLINE] = PropTypes.bool, _PropTypes$shape2[copyEditorFields.DESCRIPTION] = PropTypes.bool, _PropTypes$shape2)),
    //fields that will show up rich text editor
    toolbarOptionsSingleLine: PropTypes.array,
    toolbarOptionsMultiLine: PropTypes.array,
    toggledByDefault: PropTypes.arrayOf(PropTypes.oneOf(copyEditorFields.ALL)),
    //array of fields to toggle by default in the copy editor
    linkTextLabel: PropTypes.string,
    hasBorder: PropTypes.bool,
    focusInput: PropTypes.func,
    onChange: PropTypes.func.isRequired
  },
  defaultProps: {
    header: 'copy',
    byline: 'Add context to this module by adding a heading, byline and more',
    displayFields: copyEditorFields.COMMON,
    mentionFields: {},
    mentionList: [],
    richTextFields: {},
    toolbarOptionsSingleLine: richTextToolbar.ALL,
    toolbarOptionsMultiLine: richTextToolbar.ALL,
    toggledByDefault: [copyEditorFields.HEADING],
    ctaList: [],
    featureImageUploadLabel: null,
    featureImageSelectLabel: null,
    featureImageAllowAltText: false,
    backgroundImageUploadLabel: null,
    backgroundImageSelectLabel: null,
    backgroundImageAllowAltText: false,
    linkTextLabel: 'Link Text',
    libraryRef: '',
    containerRef: '',
    featureImageIdentifier: '',
    backgroundImageIdentifier: '',
    hasBorder: false,
    // A prop to support easier testing *only*, you should not change this default
    focusInput: function focusInput(p, id) {
      return _setTimeout(function () {
        return p.refs[id] && p.refs[id].focus();
      }, 0);
    }
  },
  state: {
    fieldsToggled: {
      value: function value(p) {
        return getToggledFields(p);
      },
      updater: 'setFieldsToggled'
    }
  },
  lifecycles: {
    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
      return this.props.header !== nextProps.header || this.props.byline !== nextProps.byline || this.props.copyConfig !== nextProps.copyConfig || this.props.fieldsToggled !== nextProps.fieldsToggled || !_.isEqual(this.props.richTextFields, nextProps.richTextFields) || !_.isEqual(this.props.mentionFields, nextProps.mentionFields) || !_.isEqual(this.props.mentionList, nextProps.mentionList);
    }
  },
  refs: ['tagline', 'heading', 'byline', 'description', 'helpText', 'linkText', 'ctaLink', 'price'],
  handlers: {
    toggleCopyOption: function toggleCopyOption(p) {
      return function (ev, _ref) {
        var id = _ref.id;

        var fieldsToggled = _Object$assign({}, p.fieldsToggled);

        fieldsToggled[id] = !fieldsToggled[id];

        if (!fieldsToggled[id]) {
          // field was just toggled off
          p.onChange(ev, {
            id: id,
            value: ''
          });
        } else {
          p.focusInput(p, id);
        }

        p.setFieldsToggled(fieldsToggled);
      };
    },
    toggleCtaOption: function toggleCtaOption(p) {
      return function (ev) {
        var fieldsToggled = _Object$assign({}, p.fieldsToggled);

        fieldsToggled.link = !fieldsToggled.link;

        if (!fieldsToggled.link) {
          // field was just toggled off
          p.onChange(ev, {
            id: 'link',
            value: ''
          });
          p.onChange(ev, {
            id: 'linkText',
            value: ''
          });
        } else {
          p.focusInput(p, 'ctaLink');
        }

        p.setFieldsToggled(fieldsToggled);
      };
    },
    handleCtaLinkChange: function handleCtaLinkChange(p) {
      return function (ev, _ref2) {
        var value = _ref2.value;
        p.onChange(ev, {
          id: 'link',
          value: value
        });
      };
    },
    handleCtaLinkTextChange: function handleCtaLinkTextChange(p) {
      return function (ev, _ref3) {
        var value = _ref3.value;
        p.onChange(ev, {
          id: 'linkText',
          value: value
        });
      };
    }
  },
  render: function render(p) {
    return getCopyPanel(p);
  }
});
export default CopyEditor;
//# sourceMappingURL=index.js.map